module.exports = __webpack_public_path__ + "img/undraw-subscriber-vabu.816711fa.svg";